export default __webpack_public_path__ + "static/media/a.671e1569.mp3";